<template>
    <v-container color="primary">
        <v-row justify-md="center" wrap>
            <v-col cols="1" xs="0" sm="0" md="1">
            </v-col>
            <v-col cols="10" xs="12" sm="12" md="10">
                <materialfy-header-card cardTitle='APIs' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false">
                    <template v-slot:crdInner>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <MaterialfyDataTables ref="dataTable" cardTitle="API" :showSearch="false" :actions="actions"
                            :hasActions="true" @action-clicked="handleActionClicked" :showCardTitle="false" />
                        <br>
                    </template>
                    <template #crdActions>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <v-row no-gutters justify="center">
                            <v-btn color="tertiary" @click="menuActionClick('openDialogBot')" class="mb-2"> NUEVA API
                            </v-btn>
                        </v-row>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                    </template>
                </materialfy-header-card>
                <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                    :float-right="right">
                    <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                    <div>
                        {{ msg_toast }}
                    </div>
                    <v-icon size="16" @click="snackbar = false">
                        mdi-close-circle
                    </v-icon>
                </v-snackbar>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserService from '../../services/user.service'
// import { genericApi } from "../../plugins/axios"

export default {
    data: () => ({
        title: 'APIS',
        // Table
        headers: [
            { text: "Exchange", value: "exchange", align: "center" },
            { text: 'Acciones', value: 'actions', sortable: false, align: "center" }
        ],
        itemsApis: [],
        actions: [
            { icon: 'mdi-call-made', tooltip: 'Conectar', action: 'connect' },
            { icon: 'mdi-content-save-edit-outline', tooltip: 'Modificar', action: 'update' },
            { icon: 'mdi-trash-can-outline', tooltip: 'Eliminar', action: 'delete' }
        ],
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackbar: false,
        msg_toast: '',
    }),
    mounted() {
        UserService.getClients().then(
            response => {
                if (response.data !== '') {
                    for (let i = 0; i < response.data.length; i++) {
                        let aux = { 'id': response.data[i]['id'], 'exchange': response.data[i]['exchange']['exchange'] }
                        this.itemsApis.push(aux);
                    }
                }
            },
            error => {
                this.content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );

        this.$refs.dataTable.headers = this.headers
        this.$refs.dataTable.items = this.itemsApis
    },
    methods: {
        menuActionClick(action) {
            if (action === "openDialogBot") {
                this.$router.push('/api-save');
            }
        },
        handleActionClicked({ item, action }) {
            // console.log('Action clicked in parent:', action);
            // console.log('Item:', item);
            // Aquí puedes manejar la lógica en el componente padre
            switch (action) {
                case 'connect':
                    // this.snack('bottom', 'right')
                    this.connect(item)
                    break;
                case 'update':
                    this.$router.push('/api-save/' + item.id);
                    break;
                case 'delete':
                    console.log('delete client')
                    break;
            }
        },
        connect(value) {
            UserService.getConnect(value.id).then(
                response => {
                    setTimeout(() => (this.snack('success', response.data)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.snack('error', error.response.data)), 2000)
                }
            );
        },
        snack(color, message) {
            this.top = false;
            this.bottom = false;
            this.left = false;
            this.right = false;
            this.color = color
            this.msg_toast = message
            this.snackbar = true;
        },
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
